<template>
  <div class="formContato">
    <v-form
          ref="form"
        >
          <v-text-field color="#E46C0A " :rules="validation2.rules.required"  type="text" placeholder="assunto" v-model="subject" name="assunto"></v-text-field>
      <div class="divRadio">
        <span class="radioSpan">
          <input type="radio" v-model="category" value="elogio">
          elogio
        </span>
        <span class="radioSpan">
          <input type="radio" v-model="category" value="critica">
          critica
        </span>
        <span class="radioSpan">
          <input type="radio" v-model="category" value="informação">
          informação
        </span>
        <span class="radioSpan">
          <input type="radio" v-model="category" value="sugestão">
          sugestão
        </span>
      </div>
       <v-textarea
          solo
          name="input-7-1"
          placeholder="mensagem"
          v-model="text"
          :rules="validation2.rules.required"
        ></v-textarea>
        <v-row class="file">
          <v-col cols="12">
            <a v-on:click="$refs.file.click();" v-if="!fileTemp" class="small anexar" href="javascript:void(0)">
              <img  src="../assets/img/clip.png" alt="">
              enviar anexo
              </a>
            <a v-on:click="file = null; fileTemp = null;" v-if="fileTemp" class="small anexar" style="color: red" href="javascript:void(0)">
              <img  src="../assets/img/clip.png" alt="">
              remover anexo
            </a>
          </v-col>
          <v-col cols="12">
            <div class="img-file" v-if="fileTemp">
              <img :src="fileTemp.url" alt="">
            </div>
            <input style="display:none;"  accept="image/jpg,image/png,image/jpeg" type="file" :v-model="file" name="file" id="file" v-on:change="changeFile" ref="file">
          </v-col>
        </v-row>
        <a @click="submit()" class="btn block" :disabled="loading">{{ loading ? 'aguarde...': 'enviar'}}</a>
         <v-alert dense v-if="mensagem" outlined type="success">{{ mensagem }}</v-alert>
    </v-form>
  </div>
</template>

<script>
import {VRow, VCol, VTextField,VDialog,VCard,VCardTitle,VCardText,VApp,VForm,VRadio,VRadioGroup,VTextarea,VFileInput} from 'vuetify/lib'
import * as validation from '../config/validations';
import { resolvePromise } from '../helpers/helpers';

import { enviarMensagem } from '../services/faleconosco.service';
export default {
  name: 'FormContato',
   components: {
      VForm,
      VTextarea,
      VTextField,
      VRadio,
      VRadioGroup,
      VFileInput,
      VRow, VCol
  },
  data(){
    return {
      mensagem: null,
      subject:null,
      category:'informação',
      text:null,
      file:null,
      fileTemp: null,
      loading: false,
      validation2: {
        rules: {
          required:  [ v => v !== '' && v !== null || `Campo obrigatório` ],
        }
      }
    }
  },
  methods:{
    changeFile(event) {
      this.fileTemp = false;
      const files = event.target.files;
      if( files[0] !== undefined ){
        const reader = new FileReader();
        reader.readAsDataURL(files[0]);
        reader.addEventListener('load', () => {
          this.fileTemp = { 
            url: reader.result,
            binary: files[0]
          }
        });
      }
    },
    submit(){
      const token = sessionStorage.getItem('giro-token');
      this.mensagem = null;
      let data = {
        Subject: this.subject,
        Category: this.category,
        Text: this.text,
      };
      if(this.fileTemp) {
        data.File = this.fileTemp.binary;
      }
      if(this.$refs.form.validate()){
        var formData = new FormData();
        Object.keys(data).forEach((v) => {
          formData.append(v, data[v]);
        });
        this.loading = true;
        resolvePromise(enviarMensagem(formData), ({data}) => {
          console.log('salve', data);
          this.subject = '';
          this.category = 'informação';
          this.text = '';
          this.fileTemp = null;
          this.file = null;
          this.loading = false;
          this.mensagem = "Mensagem enviada com sucesso!";
        }, (err) => { console.error(err); this.loading = false;}, this);
      }
    },
  },
  props: {}
}
</script>

<style scoped lang="scss">
  @import "../assets/scss/formContato.scss";
  .btn[disabled] { opacity: .5 }
  .btn.small {
    font-size: 14px;
    padding: 15px 10px;
  }
  .img-file {
    max-width: 100%;
    img {
      max-width: 100%;
    }
  }
  .anexar {
    display: flex;
    font-weight: bold;
    img { max-width: 24px; margin-right: 10px; }
  }
  v-alert[type='success'] {
    color: #4caf50;
    background: #EAF6EA;
    padding: 15px;
    text-align: center;
    font-weight: bold;
    display: block;
    margin-top: 20px;
    border-radius: 10px;
  }
</style>
